import Render from "./Render";

export default Render;